import { ENetworkRequestStatus } from 'services/BackendApi';
import * as Actions from './actions';
import { IInternalUserDomain, initialState } from './model';
import { update } from 'utils/immutable';

export const internalUserReducer = (
  state: IInternalUserDomain = initialState,
  action: Actions.Any
): IInternalUserDomain => {
  switch (action.type) {
    case Actions.CREATE_REQUEST:
      return update(state, s => {
        s.request.create = ENetworkRequestStatus.PENDING;
      });

    case Actions.CREATE_SUCCESS:
      return update(state, s => {
        s.request.create = ENetworkRequestStatus.SUCCESS;
      });

    case Actions.CREATE_FAILURE:
      return update(state, s => {
        s.request.create = ENetworkRequestStatus.ERROR;
      });

    case Actions.GET_REQUEST:
      return update(state, s => {
        s.request.get = ENetworkRequestStatus.PENDING;
      });

    case Actions.GET_SUCCESS:
      return update(state, s => {
        s.internalUser = action.internalUser;
        s.originalUserType = action.internalUser.type;
        s.request.get = ENetworkRequestStatus.SUCCESS;
      });

    case Actions.GET_FAILURE:
      return update(state, s => {
        s.request.get = ENetworkRequestStatus.ERROR;
      });

    case Actions.UPDATE_REQUEST:
      return update(state, s => {
        s.request.update = ENetworkRequestStatus.PENDING;
      });

    case Actions.UPDATE_SUCCESS:
      return update(state, s => {
        s.internalUser = action.internalUser;
        s.originalUserType = action.internalUser.type;
        s.request.update = ENetworkRequestStatus.SUCCESS;
      });

    case Actions.UPDATE_FAILURE:
      return update(state, s => {
        s.request.update = ENetworkRequestStatus.ERROR;
      });

    case Actions.RESET_INTERNAL_USER:
      return update(state, s => {
        s.internalUser = null;
        s.assignedDestinations = [];
        s.originalAssignedDestinations = [];
        s.originalUserType = null;
        s.request.create = ENetworkRequestStatus.IDLE;
        s.request.get = ENetworkRequestStatus.IDLE;
        s.request.update = ENetworkRequestStatus.IDLE;
        s.request.getAssignedDestinations = ENetworkRequestStatus.IDLE;
        s.request.updateAssignedDestinations = ENetworkRequestStatus.IDLE;
      });

    // Assigned Destinations actions
    case Actions.GET_ASSIGNED_DESTINATIONS_REQUEST:
      return update(state, s => {
        s.request.getAssignedDestinations = ENetworkRequestStatus.PENDING;
      });

    case Actions.GET_ASSIGNED_DESTINATIONS_SUCCESS:
      return update(state, s => {
        s.assignedDestinations = action.destinations;
        s.originalAssignedDestinations = action.destinations;
        s.request.getAssignedDestinations = ENetworkRequestStatus.SUCCESS;
      });

    case Actions.GET_ASSIGNED_DESTINATIONS_FAILURE:
      return update(state, s => {
        s.request.getAssignedDestinations = ENetworkRequestStatus.ERROR;
      });

    case Actions.UPDATE_ASSIGNED_DESTINATIONS_REQUEST:
      return update(state, s => {
        s.request.updateAssignedDestinations = ENetworkRequestStatus.PENDING;
      });

    case Actions.UPDATE_ASSIGNED_DESTINATIONS_SUCCESS:
      return update(state, s => {
        s.assignedDestinations = action.destinations;
        s.originalAssignedDestinations = action.destinations;
        s.request.updateAssignedDestinations = ENetworkRequestStatus.SUCCESS;
      });

    case Actions.UPDATE_ASSIGNED_DESTINATIONS_FAILURE:
      return update(state, s => {
        s.request.updateAssignedDestinations = ENetworkRequestStatus.ERROR;
      });

    case Actions.SET_ASSIGNED_DESTINATIONS:
      return update(state, s => {
        s.assignedDestinations = action.destinations;
      });

    default:
      return state;
  }
};

export default internalUserReducer;
